var POI_added, addPOIIdToLocation, applyFilter, applyFilterNew, applyLocationFilterNew, checkNode, checkPOI, createRootUL, current_node, displayDataAlt, expandNode, expanded, form_added, getIDfromNode, getTreeSelectedNodes, inEventHandler, loaded_locations, nodeN, reApplayFilter, removeAddClass, removeData, removeLocationFilter, removeNodes, selectChildren, selectedTopLocations, selected_loc;

current_node = null;

selected_loc = null;

inEventHandler = false;

POI_added = {};

form_added = [];

expanded = [];

nodeN = null;

window.fullHierarchy = false;

window.removedLocs = [];

selectedTopLocations = [];

loaded_locations = [];

window.islocationselected = false;

displayDataAlt = function(id, node, level) {
  var selUs;
  selUs = getSelectedUS_ID();
  if (selUs.length > 0 || ($("#from").val() !== "" && $("#to").val() !== "")) {
    return filterPOI(id);
  } else if (current === "osm") {
    return loadMapData(id, node.data.key, level - 1, node.data.center, node.data.zoom);
  } else if (current === "table") {
    return addDisplayData(id, node.data.key, level - 1);
  } else if (current === "filter") {
    return initFilter();
  }
};

expandNode = function(node) {
  return locationHierarchy.expandNode(node);
};


/*
Removes Nodes which do not have data i.e not bolded.
 */

removeNodes = function() {

  /*
  root = $("#tree").dynatree("getRoot")
  children = root.childList
  toRemoveNodes = []
  
  root.visit (childNode) ->
      p = childNode.getParent()
      if childNode.data.addClass isnt "dynatree-filter" and childNode.data.key[0] isnt "p"
          unless window.removedLocs[p.data.key]
              window.removedLocs[p.data.key] = [childNode]
          else
              window.removedLocs[p.data.key].push childNode
          toRemoveNodes.push childNode
  
  
  i = 0
  
  while i < toRemoveNodes.length
      toRemoveNodes[i].remove()
      i++
   */
};


/*
ApplyLocationFilterNew do something TODO

Called when form / poi type is selected
 */

applyLocationFilterNew = function(id) {
  var cNode, i, j, key, loadedLocs, locs, newNode, parent, parentNode, removedKeys, tempNode, tree;
  loadedLocs = POI[id].instance.loadedLocs;
  removedKeys = [];
  j = 0;
  for (key in window.removedLocs) {
    locs = window.removedLocs[key];
    tree = $("#tree").dynatree("getTree");
    i = 0;
    while (i < locs.length) {
      cNode = locs[i];
      if (cNode != null) {
        if (loadedLocs[cNode.data.key] && loadedLocs[cNode.data.key][0]) {
          removedKeys[j] = i;
          j++;
          parent = cNode.getParent();
          parentNode = tree.getNodeByKey(parent.data.key);
          if (parentNode != null) {
            parentNode.addChild({
              title: cNode.data.title,
              key: cNode.data.key,
              isLazy: true
            });
          } else {
            root.addChild({
              title: cNode.data.title,
              key: cNode.data.key,
              isLazy: true
            });
          }
          newNode = tree.getNodeByKey(cNode.data.key);
          newNode.focus(true);
          if ((loadedLocs[newNode.data.key][1] && (!newNode.isLazy() || newNode.getLevel() === 4)) || (loadedLocs[newNode.data.key] && newNode.getLevel() === 4)) {
            tempNode = $("#tree").dynatree("getTree").getNodeByKey("p" + id + "loc" + newNode.data.key);
            if (!(tempNode || POI_added[newNode.data.key + "p" + id])) {
              newNode.addChild({
                title: title,
                key: "p" + id + "loc" + newNode.data.key,
                isLazy: false,
                hideCheckbox: true,
                addClass: "poi-type"
              });
              POI_added[newNode.data.key + "p" + id] = true;
            }
          }
          applyFilterNew(id, newNode);
        }
      }
      i++;
    }
    i = 0;
    while (i < removedKeys.length) {
      delete removedLocs[key][removedKeys[i]];
      i++;
    }
  }
  $("#tree").dynatree("getRoot").render();
  if (!fullHierarchy) {
    return removeNodes();
  }
};


/*
applyFilterNew takes id of the form and a location hierarchy tree node as
arguments.
 */

applyFilterNew = function(id, node) {
  var cNode, children, i, loadedLocs, locs, newNode, tempNode, title, tree;
  children = node.getChildren();
  loadedLocs = POI[id].instance.loadedLocs;
  title = "";
  if (POI[id].smallIcon) {
    title = "<strong><img src='/icons/" + db + "/small/" + POI[id].smallIcon + "'/><label>" + POI[id].name + "</label></strong>";
  } else if (POI[id].smallIconLink !== undefined) {
    title = "<strong><img src='" + POI[id].smallIconLink + "'>" + POI[id].name + "</strong>";
  } else {
    title = POI[id].name;
  }
  if (children) {
    i = 0;
    while (children && i < children.length) {
      cNode = children[i];
      if (loadedLocs[cNode.data.key] && loadedLocs[cNode.data.key][0]) {
        cNode.focus(true);
        if ((loadedLocs[cNode.data.key][1] && (!cNode.isLazy() || cNode.getLevel() === 4)) || (loadedLocs[cNode.data.key] && cNode.getLevel() === 4)) {
          tempNode = $("#tree").dynatree("getTree").getNodeByKey("p" + id + "loc" + cNode.data.key);
          if (!tempNode) {
            cNode.addChild({
              title: title,
              key: "p" + id + "loc" + cNode.data.key,
              isLazy: false,
              hideCheckbox: true,
              addClass: "poi-type"
            });
            POI_added[cNode.data.key + "p" + id] = true;
          }
        }
        applyFilterNew(id, cNode);
      }
      i++;
    }
    if (removedLocs[node.data.key] && removedLocs[node.data.key].length > 0) {
      locs = removedLocs[node.data.key];
      tree = $("#tree").dynatree("getTree");
      i = 0;
      while (i < locs.length) {
        cNode = locs[i];
        if (loadedLocs[cNode.data.key] && loadedLocs[cNode.data.key][0]) {
          node.addChild({
            title: cNode.data.title,
            key: cNode.data.key,
            isLazy: true
          });
          newNode = tree.getNodeByKey(cNode.data.key);
          newNode.focus(true);
          if ((loadedLocs[newNode.data.key][1] && (!newNode.isLazy() || newNode.getLevel() === 4)) || (loadedLocs[newNode.data.key] && newNode.getLevel() === 4)) {
            tempNode = $("#tree").dynatree("getTree").getNodeByKey("p" + id + "loc" + newNode.data.key);
            if (!tempNode) {
              newNode.addChild({
                title: title,
                key: "p" + id + "loc" + newNode.data.key,
                isLazy: false,
                hideCheckbox: true,
                addClass: "poi-type"
              });
              POI_added[newNode.data.key + "p" + id] = true;
            }
          }
          applyFilterNew(id, newNode);
        }
        i++;
      }
      return node.render(true, false);
    }
  }
};

selectChildren = function() {
  var a, arr, cNode, children, i, key, level, loadedLocs, locs, newNode, node, p, root, tempNode, title, tree;
  a = getSelectedPOI_ID();
  root = window.treeNode.childList;
  arr = null;
  node = null;
  children = null;
  level = window.treeNode.getLevel();
  p = 0;
  while (p < a.length) {
    loadedLocs = POI[a[p]].instance.loadedLocs;
    if (POI[a[p]].smallIcon) {
      title = "<strong><img src='/icons/" + db + "/small/" + POI[a[p]].smallIcon + "'>" + POI[a[p]].name + "</strong>";
    } else if (POI[a[p]].smallIconLink) {
      title = "<strong><img src='" + POI[a[p]].smallIconLink + "'>" + POI[a[p]].name + "</strong>";
    } else {
      title = POI[a[p]].name;
    }
    if (loadedLocs[window.treeNode.data.key] && loadedLocs[window.treeNode.data.key][1]) {
      tempNode = $("#tree").dynatree("getTree").getNodeByKey("p" + a[p] + "loc" + window.treeNode.data.key);
      if (!(tempNode || POI_added[window.treeNode.data.key + "p" + a[p]])) {
        window.treeNode.addChild({
          title: title,
          key: "p" + a[p] + "loc" + window.treeNode.data.key,
          isLazy: false,
          hideCheckbox: true,
          addClass: "poi-type"
        });
        POI_added[window.treeNode.data.key + "p" + a[p]] = true;
      }
    }
    applyFilterNew(a[p], window.treeNode);
    p++;
  }
  for (key in removedLocs) {
    locs = removedLocs[key];
    tree = $("#tree").dynatree("getTree");
    i = 0;
    while (i < locs.length) {
      cNode = locs[i];
      if (cNode != null) {
        if (loadedLocs[cNode.data.key] && loadedLocs[cNode.data.key][0]) {
          node.addChild({
            title: cNode.data.title,
            key: cNode.data.key,
            isLazy: true
          });
          newNode = tree.getNodeByKey(cNode.data.key);
          newNode.focus(true);
          if ((loadedLocs[newNode.data.key][1] && (!newNode.isLazy() || newNode.getLevel() === 4)) || (loadedLocs[newNode.data.key] && newNode.getLevel() === 4)) {
            tempNode = $("#tree").dynatree("getTree").getNodeByKey("p" + id + "loc" + newNode.data.key);
            if (!(tempNode || POI_added[newNode.data.key + "p" + id])) {
              newNode.addChild({
                title: title,
                key: "p" + id + "loc" + newNode.data.key,
                isLazy: false,
                hideCheckbox: true,
                addClass: "poi-type"
              });
              POI_added[newNode.data.key + "p" + id] = true;
            }
          }
          applyFilterNew(id, newNode);
        }
      }
      i++;
    }
  }
  $("#tree").dynatree("getRoot").render();
  if (!fullHierarchy) {
    return removeNodes();
  }
};

removeData = function(node, level) {
  var a, i, key, results;
  a = getSelectedPOI_ID();
  i = 0;
  results = [];
  while (i < a.length) {
    for (key in POI[a[i]].instance.name) {
      if (Number(node.data.key) === POI[a[i]].instance.locations[key][level - 1]) {
        removePOIItems(a[i], key);
        if (checkPOI(POI[a[i]].ques.forms, level - 1, node.getParent().childList)) {
          $("#ft" + a[i]).html("");
        }
      }
      if (node.data.key === "0ul0" && (POI[a[i]].instance.locations[key][level - 1] === undefined || (POI[a[i]].instance.locations[key][level - 1] == null))) {
        removePOIItems(a[i], key);
        $("#ft" + a[i]).html("");
      }
    }
    results.push(i++);
  }
  return results;
};

checkNode = function(node) {
  var cNode, children, hasLoc, i, newChildren;
  if (node.getLevel() < 4 && node.hasChildren()) {
    children = node.childList;
    newChildren = [];
    hasLoc = false;
    i = 0;
    while (children && i < children.length) {
      cNode = children[i];
      if (cNode.data.key[0] === "p") {
        newChildren.push(cNode);
      } else {
        hasLoc = true;
      }
      i++;
    }
    if (!hasLoc) {
      return node.reloadChildren(function(node, isOk) {
        i = 0;
        while (i < newChildren.length) {
          cNode = newChildren[i];
          node.addChild({
            title: cNode.data.title,
            key: cNode.data.key,
            isLazy: false,
            hideCheckbox: true,
            addClass: "poi-type"
          });
          i++;
        }
        return applyFilter(node);
      });
    }
  }
};

createRootUL = function() {
  var root;
  root = $("#tree").dynatree("getRoot");
  return root.addChild({
    title: "Undefined Locations",
    key: "0ul0",
    select: false,
    focus: false,
    expand: false
  });
};


/*
removeLocationFilter takes an id as a parameter that
is the form type id
 */

removeLocationFilter = function(id) {
  var cNode, children, i, key, length, location, locations, n, node, p, results;
  n = null;
  p = null;
  locations = POI[id].instance.locations;
  for (key in locations) {
    location = locations[key];
    i = 0;
    while (i < 4) {
      node = $("#tree").dynatree("getTree").getNodeByKey("p" + id + "loc" + location[i]);
      if (node != null) {
        p = node.getParent();
        node.remove();
        if (!p.getChildren()) {
          p.resetLazy();
        }
        continue;
      }
      i++;
    }
  }
  node = $("#tree").dynatree("getTree").getNodeByKey("0ul0");
  if (node != null) {
    children = node.getChildren();
    key = "p" + id + "loc" + node.data.key;
    if (children != null) {
      length = children.length;
      i = length - 1;
      results = [];
      while (children && i >= 0) {
        cNode = children[i];
        if (cNode.data.key === key) {
          cNode.remove();
        }
        results.push(i--);
      }
      return results;
    }
  }
};

reApplayFilter = function() {
  var a, i, results;
  a = getSelectedPOI_ID();
  i = 0;
  results = [];
  while (i < a.length) {
    applyLocationFilterNew(a[i]);
    results.push(i++);
  }
  return results;
};

getTreeSelectedNodes = function() {
  if (locationHierarchyView) {
    return locationHierarchyView.getSelectedLocations();
  } else {
    return [];
  }
};

removeAddClass = function(node) {
  var child, children, k, len, results;
  node.data.addClass = '';
  children = node.childList;
  if (children != null) {
    results = [];
    for (k = 0, len = children.length; k < len; k++) {
      child = children[k];
      results.push(removeAddClass(child));
    }
    return results;
  }
};


/*
Applies filter only to the children of the given node.
 */

applyFilter = function(node) {
  var a, cNode, children, i, id, instLocs, level, p, results;
  a = getSelectedPOI_ID();
  level = node.getLevel();
  children = node.childList;
  p = 0;
  results = [];
  while (p < a.length) {
    instLocs = POI[a[p]].instance.loadedLocs;
    i = 0;
    while (children !== undefined && i < children.length) {
      cNode = children[i];
      if (cNode.data.key[0] !== "p") {
        id = cNode.data.key;
        if (instLocs[id] !== undefined) {
          cNode.data.addClass = "dynatree-filter";
        }
      }
      i++;
    }
    results.push(p++);
  }
  return results;
};

checkPOI = function(poi, level, loc) {
  var m, n, present;
  present = false;
  n = 0;
  while (loc !== undefined && n < loc.length) {
    m = 0;
    while (poi !== undefined && m < poi.length) {
      if (poi[m].location[level] === loc[n].data.key && loc[n].bSelected) {
        present = true;
      }
      m++;
    }
    n++;
  }
  if (!present) {
    return true;
  } else {
    return false;
  }
};

getIDfromNode = function(str) {
  var i, id;
  id = "";
  i = 1;
  while (str[i] !== "l") {
    id = id + str[i];
    i++;
  }
  return id;
};

addPOIIdToLocation = function(node, id) {
  try {
    if (node.data.poiIds === undefined) {
      node.data.poiIds = new Array();
    }
    node.data.poiIds.push(id);
    return node.visit(function(childNode) {
      if (childNode.data.poiIds === undefined) {
        childNode.data.poiIds = new Array();
      }
      return childNode.data.poiIds.push(id);
    });
  } finally {

  }
};

//# sourceMappingURL=maps/locations.js.map
